import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';

function Footer({ isLightMode }) {
  const theme = useTheme();
  const backgroundColor = isLightMode ? '#464047' : '#000000';
  const textColor = theme.palette.mode === 'dark' ? '#ffffff' : '#ffffff';
  const linkColor = theme.palette.mode === 'dark' ? '#2196F3' : '#2196F3';

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        backgroundColor: backgroundColor,
        textAlign: 'center',
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: '100%',
        minHeight: '10vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: '400px', // Set the initial margin-left to 400px
        [theme.breakpoints.up('sm')]: {
          justifyContent: 'space-between',
          padding: '0 20px',
          marginLeft: '0', // Reset the margin-left to 0 for larger screens
          maxWidth: '1900px', // Add a maximum width for larger screens
          margin: '0 auto', // Center the footer horizontally
        },
        [theme.breakpoints.down('sm')]: {
          marginLeft: '0', // Reset the margin-left to 0 for extra small screens
          flexDirection: 'column', // Stack content vertically
          padding: '20px 10px', // Add padding to the top and bottom
          alignItems: 'center', // Center items horizontally
          textAlign: 'center', // Center text
        },
      }}
    >
      <Typography variant="body2" sx={{ color: textColor }}>
        © {new Date().getFullYear()} My Portfolio. All rights reserved. Built with React and Material-UI. Find the code
        on GitHub:{' '}
        <Link href="https://github.com/evahaudi/myportfolio" target="_blank" rel="noopener noreferrer" sx={{ color: linkColor }}>
          GitHub Repo
        </Link>
      </Typography>
    </Box>
  );
}

export default Footer;
